export default __webpack_public_path__ + "static/media/aaron-burden-UIib0bAvWfs-unsplash.f9f34c2d.jpg";